import { ReactElement } from "react";

import { ListTenantsWithSubaccountsQuery } from "~frontend/__generated__/graphql";

import { SearchableSelect } from "./FormSelect";

export const TenantDropdown = ({
  tenants,
  onChange,
  selectedTenantId,
}: {
  tenants: ListTenantsWithSubaccountsQuery["listTenants"];
  onChange: (tenantId?: string) => Promise<void>;
  selectedTenantId?: string;
}): ReactElement => {
  const tenantOptions = tenants.map(tenant => ({
    label: `${tenant.name} (${tenant.slug})`,
    id: tenant.id,
  }));

  return (
    <SearchableSelect<string>
      selectedId={selectedTenantId}
      onChange={async newValue => {
        await onChange(newValue);
      }}
      options={tenantOptions}
      label="STW-T Tenant"
    />
  );
};

export const SubaccountDropdown = ({
  tenants,
  selectedTenantId,
  selectedSubaccountId,
  onChange,
}: {
  tenants: ListTenantsWithSubaccountsQuery["listTenants"];
  selectedTenantId?: string;
  selectedSubaccountId?: string;
  onChange: (subaccountId?: string) => Promise<void>;
}): ReactElement => {
  const tenant = tenants.find(t => t.id === selectedTenantId);
  const subaccountOptions =
    tenant?.subaccounts.map(subaccount => ({
      label: `${subaccount.name} (${subaccount.slug})`,
      id: subaccount.id,
    })) || [];

  return (
    <SearchableSelect<string>
      selectedId={selectedSubaccountId}
      onChange={async newValue => {
        await onChange(newValue);
      }}
      options={subaccountOptions}
      label="STW-T Subaccount"
    />
  );
};
